import type { UserRole } from '@/lib/types'

export const ROLE_LABEL: Record<UserRole, string> = {
  ADMIN: 'Beheerder',
  PARTNER: 'Partner',
  CONTRACTOR: 'Onderaannemer',
  EXTERNAL: 'Externe boeker',
}
const ROLE_OPTIONS: UserRole[] = ['ADMIN', 'PARTNER', 'CONTRACTOR', 'EXTERNAL']

export const ROLE_SELECT_OPTIONS = ROLE_OPTIONS.map((r) => ({ value: r, label: ROLE_LABEL[r] }))

export function formatDate(value: string | null): string {
  if (!value) return ''
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString('nl-NL')
}
